export default "__VITE_ASSET__CVcgFUsI__"